import { ConditionEnum } from './interfaces';

export const routes = {
  DEFAULT: '/automation',
  CREATE: '/automation/create',
  DETAIL: '/automation/details',
};

export const Trigger = 'trigger';
export const inactivateModalText = `All actions and conditions within the workflow will be halted for the enrolled contacts until you reactivate it.`;
export const cloneModalText = `Are you sure you want to clone this workflow?`;
export const cloningWorkflowModalText = `Cloning this workflow`;
export const clonedWorkflowModalText = `Workflow Cloned`;
export const cloningWorkflowPermissionError = `Cannot clone: Obtain permissions for all emails in the workflow before cloning`;
export const saveWorkflowSuccess = `Your workflow has been saved successfully!`;
export const publishWorkflowSuccess = `Your workflow has been published successfully!`;

export const CONTROLS_NAMES = {
  'send email': 'Email',
  'add to list': 'Add to list',
  delay: 'Delay',
  end: 'Stop',
  'If / Else': 'Condition',
};

export const EVENT_IDS = {
  EMAIL_OPEN: 7,
  EMAIL_CLICK: 8,
  EMAIL_RECEIVED: 9,
  SHARE_PROFILE: 10,
  EMAIL_SEQUENCE: 11,
  SUBSCRIBES_TO_A_LIST: 14,
};

export const days = [
  { value: 'Monday', label: 'Monday' },
  { value: 'Tuesday', label: 'Tuesday' },
  { value: 'Wednesday', label: 'Wednesday' },
  { value: 'Thursday', label: 'Thursday' },
  { value: 'Friday', label: 'Friday' },
  { value: 'Saturday', label: 'Saturday' },
  { value: 'Sunday', label: 'Sunday' },
];
export const times = [
  { value: '1 am', label: '1 am' },
  { value: '2 am', label: '2 am' },
  { value: '3 am', label: '3 am' },
  { value: '4 am', label: '4 am' },
  { value: '5 am', label: '5 am' },
  { value: '6 am', label: '6 am' },
  { value: '7 am', label: '7 am' },
  { value: '8 am', label: '8 am' },
  { value: '9 am', label: '9 am' },
  { value: '10 am', label: '10 am' },
  { value: '11 am', label: '11 am' },
  { value: '12 am', label: '12 am' },
  { value: '1 pm', label: '1 pm' },
  { value: '2 pm', label: '2 pm' },
  { value: '3 pm', label: '3 pm' },
  { value: '4 pm', label: '4 pm' },
  { value: '5 pm', label: '5 pm' },
  { value: '6 pm', label: '6 pm' },
  { value: '7 pm', label: '7 pm' },
  { value: '8 pm', label: '8 pm' },
  { value: '9 pm', label: '9 pm' },
  { value: '10 pm', label: '10 pm' },
  { value: '11 pm', label: '11 pm' },
  { value: '12 pm', label: '12 pm' },
];

export const operatorOptions = [
  { label: 'AND', value: 'AND' },
  { label: 'OR', value: 'OR' },
];

export const initialCondition = [
  {
    emailId: 0,
    emailType: '',
    emailName: '',
    link: '',
    linkType: '',
    sp_uuid: '',
    controlId: 3,
    controlName: ConditionEnum.HAS_OPENED,
  },
];

export const initialDelayCondition = [
  {
    emailId: 0,
    emailType: '',
    emailName: '',
    link: '',
    linkType: '',
    sp_uuid: '',
    controlId: 3,
    controlName: ConditionEnum.HAS_OPENED,
    timezone: '',
    verb: 'Is',
    day: '',
    time: '',
  },
];
